module.exports = __webpack_public_path__ + "static/media/СЗФО_2015.1a9fb3e4.png";